import { FunctionalComponent, h } from '@stencil/core';
import OwnerDistanceProps from './types';
import Text from '../Text';

import { caiEvent } from '@/utils';
import { ELOT_ANALYTICS } from '@/constants/elotEvents';

const OwnerDistance: FunctionalComponent<OwnerDistanceProps> = ({ analyticsData, classNames, owner, inventoryId, ...rest }) => {
    const { distanceFromSearch, id, name = '', website} = owner;

    const isDistanceViewable = (!!distanceFromSearch || distanceFromSearch === 0);

    const handleClick = (event) => {
        event.stopPropagation();
        caiEvent.send(ELOT_ANALYTICS, {
            action: 'ownerWebsite',
            data: {
                ownerId: id,
                inventoryId,
            },
        });
        window.open(website?.href, "_blank");
    };

    let ownerTitle = name;
    if (website?.href) {
        ownerTitle = (
            <span 
                class="text-link text-bold text-size-200" 
                aria-label={name}
                onClick={handleClick}
            >
                {name}
                <span class="margin-left-1 display-inline glyphicon glyphicon-offsite"></span>
            </span>
        )
    } else {
        ownerTitle = (
            <Text 
                weight='bold'
                content={name}
                aria-label={name} 
                size="200"
            />
        )
    }
    
    const distanceLabel = distanceFromSearch + ' mi. away';

    return (isDistanceViewable || ownerTitle) ? (
        <div
            key="ownerDistance"
            data-cmp="ownerDistance"
            class={classNames}
            {...rest}
        >
            {ownerTitle}
            {isDistanceViewable && (
                <Text color='subdued-lighter' content={`(${distanceLabel})`} size='200' />
            )}
        </div>
    ) : null;
};

export default OwnerDistance;
